import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Album from './pages/Album';
import Favorites from './pages/Favorites';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import ProfileEdit from './pages/ProfileEdit';
import Search from './pages/Search';

class Routes extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path="/search"
            component={ Search }
          />
          <Route
            path="/album/:id"
            render={ (props) => <Album { ...props } /> }
          />
          <Route
            path="/favorites"
            component={ Favorites }
          />
          <Route
            path="/profile/edit"
            component={ ProfileEdit }
          />
          <Route
            path="/profile"
            component={ Profile }
          />
          <Route
            exact
            path="/"
            component={ Login }
          />
          <Route path="*" component={ NotFound } />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default Routes;
